/* SolidStep — scripts. Zéro dépendance. Mobile first.
   Règles :
   - aucune variante n'est envoyée au panier sans sélection explicite du client
   - aucun prix n'est calculé ni inventé ici : Shopify reste la seule source de vérité
   - les remises de packs sont appliquées par Shopify, jamais par ce fichier
*/
(function () {
  'use strict';

  /* Le retrait de « no-js » n'a lieu QUE si ce fichier s'exécute réellement.
     Si le script échoue à se charger, la règle html.no-js du CSS garde tout le contenu visible. */
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var closest = function (el, sel) {
    while (el && el.nodeType === 1) { if (el.matches && el.matches(sel)) return el; el = el.parentElement; }
    return null;
  };

  /* ---------------------------------------------------------------- Monnaie */
  function money(cents) {
    var f = (window.SolidStep && window.SolidStep.moneyFormat) || '{{amount_with_comma_separator}} €';
    var n = Math.round(cents) / 100;
    function group(value, dec, thou) {
      var parts = value.toFixed(2).split('.');
      var int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec === null ? int : int + dec + parts[1];
    }
    return f
      .replace(/\{\{\s*amount\s*\}\}/g, group(n, '.', ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(n, ',', '.'))
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, group(n, ',', ' '))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' '));
  }

  /* ------------------------------------------------------ Révélation scroll */
  function reveal(scope) {
    var els = $$('[data-reveal]', scope).filter(function (e) { return !e.__ssReveal; });
    if (!els.length) return;
    els.forEach(function (e) { e.__ssReveal = 1; });
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = parseInt(e.target.getAttribute('data-reveal-delay') || 0, 10);
        setTimeout(function () { e.target.classList.add('is-in'); }, d);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: .1 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* --------------------------------- Cases « Vous vous reconnaissez ? » */
  function recognition(scope) {
    $$('[data-recog]', scope).forEach(function (list) {
      if (list.__ss) return; list.__ss = 1;
      if (!('IntersectionObserver' in window)) {
        $$('.recog__i', list).forEach(function (i) { i.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (!e.isIntersecting) return;
          $$('.recog__i', e.target).forEach(function (item, i) {
            setTimeout(function () { item.classList.add('is-in'); }, 220 + i * 260);
          });
          io.unobserve(e.target);
        });
      }, { threshold: .35 });
      io.observe(list);
    });
  }

  /* ------------------------------------------------------------- En-tête */
  function header() {
    var h = $('[data-header]'); if (!h || h.__ss) return; h.__ss = 1;
    var on = function () { h.classList.toggle('is-stuck', window.scrollY > 6); };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  /* -------------------------------------------------------------- Drawers */
  var lastFocus = null, openCount = 0, savedScroll = 0;

  function lockScroll() {
    if (openCount++ > 0) return;
    savedScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top = (-savedScroll) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlockScroll() {
    openCount = Math.max(0, openCount - 1);
    if (openCount > 0) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScroll);
  }
  function focusables(root) {
    return $$('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])', root)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function openDrawer(id, opener) {
    var d = document.getElementById(id); if (!d || d.classList.contains('is-open')) return;
    lastFocus = opener || document.activeElement;
    d.classList.add('is-open');
    d.removeAttribute('aria-hidden');
    lockScroll();
    $$('[data-drawer-open="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () {
      var f = focusables($('.drw__pan', d) || d)[0];
      if (f) f.focus();
    }, 220);
  }
  function closeDrawer(d) {
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    unlockScroll();
    $$('[data-drawer-open="' + d.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function drawers() {
    document.addEventListener('click', function (e) {
      var o = closest(e.target, '[data-drawer-open]');
      if (o) {
        var id = o.getAttribute('data-drawer-open');
        if (document.getElementById(id)) { e.preventDefault(); openDrawer(id, o); }
        return; /* si le drawer n'existe pas, le lien de repli fonctionne normalement */
      }
      if (closest(e.target, '[data-drawer-close]')) closeDrawer(closest(e.target, '.drw'));
    });
    document.addEventListener('keydown', function (e) {
      /* plusieurs panneaux peuvent être ouverts : on agit toujours sur celui du dessus */
      var open = $$('.drw.is-open'); if (!open.length) return;
      var d = open[open.length - 1];
      if (e.key === 'Escape') { closeDrawer(d); return; }
      if (e.key !== 'Tab') return;
      var f = focusables($('.drw__pan', d) || d);
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    });
  }

  /* -------------------------------------------------------- Barre d'annonce */
  function announce(scope) {
    $$('[data-announce]', scope).forEach(function (bar) {
      if (bar.__ssTimer) { clearInterval(bar.__ssTimer); bar.__ssTimer = null; }
      var s = $$('.announce__slide', bar);
      if (s.length < 2) return;
      var i = 0, sp = parseInt(bar.getAttribute('data-speed') || 4500, 10);
      bar.__ssTimer = setInterval(function () {
        s[i].classList.remove('is-active');
        i = (i + 1) % s.length;
        s[i].classList.add('is-active');
      }, sp);
    });
  }

  /* ------------------------------------------------------------------ FAQ */
  function faq(scope) {
    $$('[data-faq]', scope).forEach(function (root) {
      if (root.__ss) return; root.__ss = 1;
      $$('.faq__q', root).forEach(function (btn, n) {
        var item = closest(btn, '.faq__i'), panel = $('.faq__a', item);
        if (panel && !panel.id) {
          panel.id = 'faq-' + (root.id || 'p') + '-' + n + '-' + Math.random().toString(36).slice(2, 7);
          btn.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'region');
        }
        btn.addEventListener('click', function () {
          var open = item.classList.contains('is-open');
          $$('.faq__i.is-open', root).forEach(function (o) {
            o.classList.remove('is-open');
            var pa = $('.faq__a', o); if (pa) pa.style.maxHeight = null;
            var qa = $('.faq__q', o); if (qa) qa.setAttribute('aria-expanded', 'false');
          });
          if (!open) {
            item.classList.add('is-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
    if (!faq.__resize) {
      faq.__resize = 1;
      window.addEventListener('resize', function () {
        $$('.faq__i.is-open .faq__a').forEach(function (p) { p.style.maxHeight = p.scrollHeight + 'px'; });
      });
    }
  }

  /* ------------------------------------------------------------- Carrousels */
  function rails(scope) {
    $$('[data-rail]', scope).forEach(function (rail) {
      if (rail.__ss) return; rail.__ss = 1;
      var dots = document.querySelector('[data-rail-dots="' + rail.getAttribute('data-rail') + '"]');
      if (!dots) return;
      var items = Array.prototype.slice.call(rail.children);
      if (!items.length) return;
      dots.innerHTML = items.map(function (_, i) { return '<span' + (i === 0 ? ' class="is-active"' : '') + '></span>'; }).join('');
      var spans = $$('span', dots);
      rail.addEventListener('scroll', function () {
        var idx = Math.round(rail.scrollLeft / (rail.scrollWidth / items.length));
        spans.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    });
  }

  /* --------------------------------------------------------------- Galerie */
  function gallery(scope) {
    $$('[data-gallery]', scope).forEach(function (g) {
      if (g.__ss) return; g.__ss = 1;
      var slides = $('[data-slides]', g), thumbs = $$('[data-thumb]', g);
      if (!slides) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          slides.scrollTo({ left: slides.clientWidth * parseInt(t.getAttribute('data-thumb'), 10), behavior: 'smooth' });
        });
      });
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach(function (x, n) {
          var on = parseInt(x.getAttribute('data-thumb'), 10) === i;
          x.classList.toggle('is-active', on);
          x.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }, { passive: true });
      g.addEventListener('ss:media', function (e) {
        var off = parseInt(g.getAttribute('data-media-offset') || 0, 10);
        var idx = e.detail.index;
        if (idx >= 0) slides.scrollTo({ left: slides.clientWidth * (idx + off), behavior: 'smooth' });
      });
    });
  }

  /* ----------------------------------------------------------------- Toast */
  function toast(msg) {
    var t = $('#ss-toast');
    if (!t) { t = document.createElement('div'); t.id = 'ss-toast'; t.className = 'toast'; document.body.appendChild(t); }
    t.innerHTML = '<svg class="ico" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg><span></span>';
    $('span', t).textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._to);
    t._to = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  /* ----------------------------------------------------------------- Panier */
  function setCount(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });
  }
  function refreshDrawer() {
    if (!$('[data-cart-content]')) return Promise.resolve();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-content]');
        var target = $('[data-cart-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }
  function addToCart(items, opts) {
    opts = opts || {};
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        setCount(cart);
        if (opts.redirect) { window.location.href = '/checkout'; return; }
        return refreshDrawer().then(function () {
          if (document.getElementById('cart-drawer')) openDrawer('cart-drawer');
          else window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
        });
      })
      .catch(function (e) {
        toast((e && e.description) || 'Ce produit est momentanément indisponible.');
        throw e;
      });
  }

  function cartEvents() {
    document.addEventListener('click', function (e) {
      var b = closest(e.target, '[data-change]'); if (!b) return;
      e.preventDefault();
      if (b.__busy) return;
      b.__busy = true;
      var row = closest(b, '.citem'); if (row) row.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: parseInt(b.getAttribute('data-change'), 10) })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          setCount(cart);
          if ($('[data-cart-page]')) { window.location.reload(); return; }
          return refreshDrawer();
        })
        .catch(function () { toast('Impossible de mettre à jour le panier.'); })
        .then(function () { b.__busy = false; if (row) row.classList.remove('is-busy'); });
    });
  }

  /* ------------------------------------------------------------------ Packs */
  function packs(scope) {
    $$('[data-packs]', scope).forEach(function (root) {
      if (root.__ss) return; root.__ss = 1;
      var cards = $$('.pack', root);
      if (!cards.length) return;

      function select(card) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-selected', on);
          var i = $('input[type="radio"]', c);
          if (i) { i.checked = on; }
          /* les champs d'un pack non sélectionné sortent du parcours clavier */
          $$('select', c).forEach(function (s) { s.disabled = !on; });
        });
        var name = $('.pack__name', card);
        root.dispatchEvent(new CustomEvent('ss:pack', {
          bubbles: true,
          detail: {
            qty: parseInt(card.getAttribute('data-qty') || 1, 10),
            /* prix d'affichage du pack, calculé côté Liquid : jamais envoyé au panier */
            price: parseInt(card.getAttribute('data-price') || 0, 10),
            compare: parseInt(card.getAttribute('data-compare') || 0, 10),
            label: (name ? name.textContent : '').trim()
          }
        }));
      }

      cards.forEach(function (c) {
        var input = $('input[type="radio"]', c);
        if (input) {
          input.addEventListener('change', function () { if (input.checked) select(c); });
        }
        c.addEventListener('click', function (e) {
          if (closest(e.target, 'select') || closest(e.target, 'label.pair__lbl')) return;
          select(c);
        });
      });

      var def = root.querySelector('.pack.is-selected') || cards[0];
      if (def) select(def);
    });
  }

  /* -------------------------------------------------------- Formulaire produit */
  function productForms(scope) {
    $$('[data-product-form]', scope).forEach(setupProductForm);
  }

  function setupProductForm(root) {
    if (root.__ss) return; root.__ss = 1;

    var dataEl = $('[data-product-json]', root);
    var product = null;
    if (dataEl) { try { product = JSON.parse(dataEl.textContent); } catch (e) { product = null; } }
    var btn = $('[data-atc]', root);
    if (!product || !product.variants || !product.variants.length) return; /* mode vitrine */

    var optCount = (product.options || []).length;
    var isPrimary = root.hasAttribute('data-primary');
    var priceEl = $('[data-price]', root), oldEl = $('[data-compare]', root), saveEl = $('[data-save]', root);
    var msgEl = $('[data-atc-msg]', root);
    var labelEl = $('[data-atc-label]', root);
    var defaultLabel = labelEl ? labelEl.textContent.trim() : 'Ajouter au panier';
    var soldLabel = (btn && btn.getAttribute('data-sold-label')) || 'Rupture de stock';

    var state = { qty: 1, packLabel: '', packPrice: 0, packCompare: 0, pairs: [] };

    function blank() { var a = []; for (var i = 0; i < optCount; i++) a.push(null); return a; }
    function pair(i) { while (state.pairs.length <= i) state.pairs.push(blank()); return state.pairs[i]; }

    /* Une option dont toutes les variantes partagent l'unique valeur n'est pas un choix : on la fixe. */
    (function presetUnique() {
      var p0 = pair(0);
      for (var i = 0; i < optCount; i++) {
        var seen = [];
        for (var k = 0; k < product.variants.length; k++) {
          var val = product.variants[k].options[i];
          if (seen.indexOf(val) === -1) seen.push(val);
        }
        if (seen.length === 1) p0[i] = seen[0];
      }
      /* Lien partagé avec ?variant= : on reprend exactement la variante demandée. */
      var pre = root.getAttribute('data-selected-variant');
      if (pre) {
        for (var j = 0; j < product.variants.length; j++) {
          if (String(product.variants[j].id) === String(pre)) {
            for (var o = 0; o < optCount; o++) p0[o] = product.variants[j].options[o];
            break;
          }
        }
      }
    })();

    function resolve(values) {
      if (!values) return null;
      for (var i = 0; i < optCount; i++) if (!values[i]) return null;
      for (var k = 0; k < product.variants.length; k++) {
        var v = product.variants[k], ok = true;
        for (var j = 0; j < optCount; j++) if (v.options[j] !== values[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }

    /* 'available' | 'soldout' | 'none' pour une valeur donnée, compte tenu des autres choix */
    function status(idx, value, values) {
      var found = 'none';
      for (var k = 0; k < product.variants.length; k++) {
        var v = product.variants[k];
        if (v.options[idx] !== value) continue;
        var ok = true;
        for (var j = 0; j < optCount; j++) {
          if (j === idx) continue;
          if (values[j] && v.options[j] !== values[j]) { ok = false; break; }
        }
        if (!ok) continue;
        if (v.available) return 'available';
        found = 'soldout';
      }
      return found;
    }

    function setValue(pi, idx, value) {
      var vals = pair(pi);
      vals[idx] = value || null;
      /* une valeur devenue incompatible est effacée plutôt que de mener à une combinaison fantôme */
      for (var j = 0; j < optCount; j++) {
        if (j === idx || !vals[j]) continue;
        if (status(j, vals[j], vals) === 'none') vals[j] = null;
      }
      render();
    }

    function selectedPack() { return $('.pack.is-selected', root); }
    function pairsRoot() {
      var pk = selectedPack();
      return pk ? $('[data-pairs]', pk) : $('[data-pairs]', root);
    }

    /* ------------------------------------------------------------- rendu */
    function renderOptionButtons() {
      var vals = pair(0);
      $$('[data-opt]', root).forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-opt'), 10);
        var val = el.getAttribute('data-val');
        var st = status(idx, val, vals);
        var active = vals[idx] === val;
        el.classList.toggle('is-active', active);
        el.classList.toggle('is-soldout', st !== 'available');
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (st === 'none') el.setAttribute('aria-disabled', 'true'); else el.removeAttribute('aria-disabled');
      });
      $$('[data-opt-group]', root).forEach(function (g) {
        var idx = parseInt(g.getAttribute('data-opt-group'), 10);
        g.classList.toggle('opt--missing', !vals[idx]);
      });
    }

    function renderPairs() {
      var pr = pairsRoot();
      if (!pr) return;
      $$('[data-pair]', pr).forEach(function (pel) {
        var pi = parseInt(pel.getAttribute('data-pair'), 10);
        var vals = pair(pi);
        $$('[data-pair-opt]', pel).forEach(function (sel) {
          var idx = parseInt(sel.getAttribute('data-pair-opt'), 10);
          if (sel.value !== (vals[idx] || '')) sel.value = vals[idx] || '';
          $$('option', sel).forEach(function (op) {
            if (!op.value) return;
            var st = status(idx, op.value, vals);
            op.disabled = st === 'none';
            var base = op.getAttribute('data-label') || op.textContent.replace(/\s+—\s+épuisé$/, '');
            op.setAttribute('data-label', base);
            op.textContent = st === 'soldout' ? base + ' — épuisé' : base;
          });
          sel.classList.toggle('is-missing', !vals[idx]);
        });
        var msg = $('[data-pair-msg]', pel);
        if (msg) {
          var complete = true;
          for (var i = 0; i < optCount; i++) if (!vals[i]) { complete = false; break; }
          if (!complete) msg.textContent = '';
          else {
            var v = resolve(vals);
            if (!v) msg.textContent = "Cette combinaison n'existe pas.";
            else if (!v.available) msg.textContent = 'Momentanément indisponible.';
            else msg.textContent = '';
          }
          msg.classList.toggle('is-on', !!msg.textContent);
        }
      });
    }

    /* Retourne { ok:true, items:[] } ou { ok:false, reason, optionName, pairIndex } */
    function evaluate() {
      var map = {}, order = [];
      for (var i = 0; i < state.qty; i++) {
        var vals = pair(i);
        for (var j = 0; j < optCount; j++) {
          if (!vals[j]) return { ok: false, reason: 'missing', optionName: product.options[j], pairIndex: i };
        }
        var v = resolve(vals);
        if (!v) return { ok: false, reason: 'nocombo', pairIndex: i };
        if (!v.available) return { ok: false, reason: 'soldout', pairIndex: i };
        if (!map[v.id]) { map[v.id] = 0; order.push(v.id); }
        map[v.id]++;
      }
      var items = order.map(function (id) {
        var it = { id: parseInt(id, 10), quantity: map[id] };
        if (state.packLabel) it.properties = { 'Pack': state.packLabel };
        return it;
      });
      return { ok: true, items: items };
    }

    function render() {
      renderOptionButtons();
      renderPairs();

      var v0 = resolve(pair(0));
      var unit = v0 ? v0.price : (product.price || 0);
      var unitOld = v0 ? v0.compare_at_price : (product.compare_at_price || 0);
      /* Un pack peut porter un prix d'offre : il ne sert QU'À L'AFFICHAGE.
         Le panier reçoit toujours les variantes et les quantités réelles ;
         c'est Shopify qui applique la remise et calcule le montant facturé. */
      var total = state.packPrice > 0 ? state.packPrice : unit * state.qty;
      var totalOld = state.packPrice > 0 ? state.packCompare : unitOld * state.qty;

      if (priceEl) priceEl.textContent = money(total);
      if (oldEl) {
        var show = totalOld > total;
        oldEl.textContent = show ? money(totalOld) : '';
        oldEl.style.display = show ? '' : 'none';
      }
      if (saveEl) {
        if (totalOld > total) {
          var pct = Math.round((totalOld - total) / totalOld * 100);
          saveEl.textContent = 'Vous économisez ' + money(totalOld - total) + ' · −' + pct + ' %';
          saveEl.style.display = '';
        } else { saveEl.textContent = ''; saveEl.style.display = 'none'; }
      }
      if (isPrimary) {
        var sp = $('[data-sticky-price]');
        if (sp) {
          sp.innerHTML = '';
          var b = document.createElement('b'); b.textContent = money(total); sp.appendChild(b);
          if (totalOld > total) { var s = document.createElement('s'); s.textContent = money(totalOld); sp.appendChild(s); }
        }
      }
      if (v0 && v0.media >= 0) {
        var g = $('[data-gallery]', root) || $('[data-gallery]');
        if (g) g.dispatchEvent(new CustomEvent('ss:media', { detail: { index: v0.media } }));
      }

      var ev = evaluate();
      if (btn) {
        btn.disabled = !ev.ok;
        btn.setAttribute('aria-disabled', ev.ok ? 'false' : 'true');
      }
      if (labelEl) labelEl.textContent = (!ev.ok && ev.reason === 'soldout') ? soldLabel : defaultLabel;
      if (msgEl) {
        var text = '';
        if (!ev.ok) {
          if (ev.reason === 'missing') text = 'Choisissez : ' + ev.optionName + (state.qty > 1 ? ' (paire ' + (ev.pairIndex + 1) + ')' : '');
          else if (ev.reason === 'nocombo') text = "Cette combinaison n'est pas disponible" + (state.qty > 1 ? ' (paire ' + (ev.pairIndex + 1) + ')' : '') + '.';
          else if (ev.reason === 'soldout') text = 'Cette sélection est momentanément indisponible' + (state.qty > 1 ? ' (paire ' + (ev.pairIndex + 1) + ')' : '') + '.';
        }
        msgEl.textContent = text;
        msgEl.classList.toggle('is-on', !!text);
      }
    }

    /* ---------------------------------------------------------- écoutes */
    root.addEventListener('click', function (e) {
      var el = closest(e.target, '[data-opt]');
      if (!el || !root.contains(el)) return;
      e.preventDefault();
      setValue(0, parseInt(el.getAttribute('data-opt'), 10), el.getAttribute('data-val'));
    });

    root.addEventListener('change', function (e) {
      var sel = closest(e.target, '[data-pair-opt]');
      if (!sel) return;
      var pel = closest(sel, '[data-pair]');
      if (!pel) return;
      setValue(parseInt(pel.getAttribute('data-pair'), 10), parseInt(sel.getAttribute('data-pair-opt'), 10), sel.value);
    });

    root.addEventListener('ss:pack', function (e) {
      state.qty = e.detail.qty || 1;
      state.packLabel = e.detail.label || '';
      state.packPrice = e.detail.price || 0;
      state.packCompare = e.detail.compare || 0;
      pair(state.qty - 1);
      render();
    });

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled || btn.__busy) return;
        var ev = evaluate();
        if (!ev.ok) {
          render();
          var target = $('.pair__sel.is-missing', pairsRoot() || root) || $('.opt--missing [data-opt]', root);
          if (target) { try { target.focus(); } catch (err) {} }
          if (msgEl && msgEl.textContent) toast(msgEl.textContent);
          return;
        }
        btn.__busy = true;
        btn.classList.add('is-loading');
        btn.insertAdjacentHTML('beforeend', '<span class="btn-loader"></span>');
        var done = function () {
          btn.__busy = false;
          btn.classList.remove('is-loading');
          var l = $('.btn-loader', btn); if (l) l.remove();
        };
        addToCart(ev.items, { redirect: btn.hasAttribute('data-direct-checkout') }).then(done, done);
      });
    }

    render();
  }

  /* ------------------------------------------------ Comparateur avant/après */
  function compare(scope) {
    $$('[data-compare]', scope).forEach(function (root) {
      if (root.__ss) return; root.__ss = 1;
      var range = $('[data-compare-range]', root);
      if (!range) return;
      /* Le champ natif gère le glisser, le tactile et le clavier :
         on se contente de reporter sa valeur sur la découpe CSS. */
      function apply() {
        var v = parseFloat(range.value);
        if (isNaN(v)) v = 50;
        v = Math.max(0, Math.min(100, v));
        root.style.setProperty('--p', v + '%');
        range.setAttribute('aria-valuetext', Math.round(v) + ' %');
      }
      apply();
      range.addEventListener('input', apply);
      range.addEventListener('change', apply);
    });
  }

  /* ------------------------------------------------------------ Sticky CTA */
  function sticky(scope) {
    $$('[data-sticky]', scope).forEach(function (bar) {
      if (bar.__ss) return; bar.__ss = 1;
      var anchor = $('[data-anchor]');
      /* on ne détourne le clic que si l'ancre contient réellement un formulaire d'achat */
      var buyable = anchor && anchor.querySelector('[data-atc]');
      function on() {
        var show = anchor ? (anchor.getBoundingClientRect().bottom < 0) : window.scrollY > 700;
        var atEnd = (document.body.scrollHeight - window.scrollY - window.innerHeight) < 150;
        bar.classList.toggle('is-visible', show && !atEnd);
      }
      on(); window.addEventListener('scroll', on, { passive: true });
      var b = $('[data-sticky-cta]', bar);
      if (b && buyable) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
          var first = $('.pair__sel.is-missing', anchor) || $('[data-atc]', anchor);
          if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) {} }, 500);
        });
      }
      /* sinon : le lien conserve son href et mène réellement au produit */
    });
  }

  /* ------------------------------------------------------- Initialisation */
  function safe(fn, scope) {
    try { fn(scope); } catch (e) { if (window.console && console.warn) console.warn('[SolidStep]', e); }
  }

  var globalDone = false;
  function initGlobal() {
    if (globalDone) return; globalDone = true;
    safe(drawers); safe(cartEvents); safe(header);
  }
  function initScoped(scope) {
    safe(reveal, scope); safe(recognition, scope); safe(announce, scope); safe(faq, scope);
    safe(rails, scope); safe(gallery, scope); safe(productForms, scope); safe(packs, scope);
    safe(sticky, scope); safe(compare, scope);
  }
  function init() { initGlobal(); initScoped(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Éditeur de thème : on ne réinitialise que la section rechargée */
  document.addEventListener('shopify:section:load', function (e) {
    initGlobal();
    initScoped(e.target || document);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var bar = e.target && e.target.querySelector ? e.target.querySelector('[data-announce]') : null;
    if (bar && bar.__ssTimer) clearInterval(bar.__ssTimer);
  });

  window.SolidStep = window.SolidStep || {};
  window.SolidStep.toast = toast;
  window.SolidStep.addToCart = addToCart;
  window.SolidStep.money = money;
})();
